import { render, staticRenderFns } from "./myhot.vue?vue&type=template&id=33137f85&scoped=true"
import script from "./myhot.vue?vue&type=script&lang=js"
export * from "./myhot.vue?vue&type=script&lang=js"
import style0 from "./myhot.vue?vue&type=style&index=0&id=33137f85&prod&lang=css"
import style1 from "./myhot.vue?vue&type=style&index=1&id=33137f85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33137f85",
  null
  
)

export default component.exports